import { JSX } from 'react'

import { IconProps } from '../../icon'

const Show: (props: IconProps) => JSX.Element = ({
  dataTestId,
  fill,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill={fill}
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M39.0637 21.629C33.2577 15.1829 24.9258 15 24 15C21.1906 15.0246 18.4158 15.6221 15.8454 16.7561C13.2749 17.89 10.9628 19.5364 9.05057 21.5947C8.39701 22.2689 8.02214 23.1651 8.00095 24.1038C7.97976 25.0426 8.31381 25.9548 8.93627 26.6578C14.7423 33.1039 23.0742 33.2868 24 33.2868C26.8094 33.2622 29.5841 32.6646 32.1546 31.5307C34.7251 30.3968 37.0372 28.7503 38.9494 26.6921C39.603 26.0179 39.9779 25.1217 39.9991 24.1829C40.0202 23.2442 39.6862 22.332 39.0637 21.629ZM37.2922 25.1149C35.5933 26.9483 33.5383 28.416 31.2528 29.428C28.9673 30.4401 26.4994 30.9753 24 31.0009C23.6686 31.0009 15.8624 30.9323 10.6392 25.1263C10.4 24.8529 10.274 24.4986 10.2867 24.1355C10.2995 23.7725 10.45 23.4279 10.7078 23.1719C12.4067 21.3384 14.4617 19.8708 16.7472 18.8588C19.0327 17.8467 21.5006 17.3115 24 17.2858C24.3314 17.2858 32.1376 17.3544 37.3608 23.1605C37.6 23.4339 37.726 23.7882 37.7133 24.1512C37.7005 24.5143 37.55 24.8589 37.2922 25.1149Z'
      fill='black'
    />
    <path
      d='M24 18.4288C22.8698 18.4288 21.7649 18.7639 20.8251 19.3919C19.8854 20.0198 19.1529 20.9123 18.7204 21.9565C18.2879 23.0007 18.1747 24.1497 18.3952 25.2583C18.6157 26.3668 19.16 27.385 19.9592 28.1842C20.7584 28.9834 21.7766 29.5277 22.8852 29.7482C23.9937 29.9687 25.1427 29.8555 26.1869 29.423C27.2311 28.9905 28.1236 28.258 28.7515 27.3183C29.3795 26.3785 29.7146 25.2736 29.7146 24.1434C29.7146 22.6278 29.1126 21.1742 28.0409 20.1025C26.9692 19.0308 25.5156 18.4288 24 18.4288ZM24 27.5722C23.3219 27.5722 22.659 27.3711 22.0951 26.9943C21.5312 26.6175 21.0918 26.082 20.8322 25.4555C20.5727 24.829 20.5048 24.1396 20.6371 23.4745C20.7694 22.8094 21.096 22.1984 21.5755 21.7189C22.055 21.2394 22.666 20.9128 23.3311 20.7805C23.9962 20.6482 24.6856 20.7161 25.3122 20.9756C25.9387 21.2351 26.4742 21.6746 26.8509 22.2385C27.2277 22.8023 27.4288 23.4652 27.4288 24.1434C27.4288 25.0528 27.0675 25.9249 26.4245 26.5679C25.7815 27.2109 24.9094 27.5722 24 27.5722Z'
      fill='black'
    />
  </svg>
)

export default Show
